/* Corporate Coffee — theme.js
 * Cart drawer, variant picker, quantity stepper, predictive search,
 * sticky header, scroll reveal, mobile drawer, filter auto-submit.
 */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'AED'
      }).format(cents / 100);
    } catch (e) {
      return 'AED ' + (cents / 100).toFixed(2);
    }
  }

  // ─── Sticky header shadow ──────────────────────────────────
  var hdr = $('.site-header');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ─── Scroll reveal ─────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) {
          setTimeout(function () { e.target.classList.add('in'); }, i * 70);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    $$('.reveal').forEach(function (el) { obs.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  // ─── Drawers: cart, search, mobile menu ────────────────────
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    // Only auto-focus search-style inputs, not filter fields
    if (id === 'search-drawer') {
      setTimeout(function () {
        var input = d.querySelector('input[type=search]');
        if (input) input.focus();
      }, 200);
    }
  }
  function closeDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[aria-hidden="false"].cart-drawer, [aria-hidden="false"].search-drawer, [aria-hidden="false"].mobile-drawer, [aria-hidden="false"].filter-drawer')) {
      document.body.classList.remove('drawer-open');
    }
  }

  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer('cart-drawer'); }); });
  $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer('search-drawer'); }); });
  $$('[data-close-drawer]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer('cart-drawer'); }); });
  $$('[data-close-search]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer('search-drawer'); }); });
  $$('[data-close-mobile]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer('mobile-drawer'); }); });

  var ham = $('#site-hamburger');
  if (ham) ham.addEventListener('click', function () { openDrawer('mobile-drawer'); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer('cart-drawer'); closeDrawer('search-drawer'); closeDrawer('mobile-drawer'); closeDrawer('filter-drawer');
    }
  });

  // ─── Cart API helpers ──────────────────────────────────────
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update count badges
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        $$('[data-cart-count-text]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
        $$('[data-cart-subtotal]').forEach(function (el) {
          el.textContent = money(cart.total_price);
        });
        return cart;
      });
  }

  // Icon SVGs (mirror snippets/icon.liquid) for client-rendered drawer rows
  var ICON = {
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url, w) {
    if (!url) return '';
    if (url.indexOf('width=') !== -1) return url;
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w;
  }

  // Rebuild the drawer body + footer directly from /cart.js (no Section API needed)
  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.querySelector('[data-cart-drawer-body]');
        var panel = document.querySelector('#cart-drawer .cart-drawer-panel');
        if (body) {
          if (cart.item_count > 0) {
            body.innerHTML = cart.items.map(function (item) {
              var img = item.image
                ? '<img src="' + esc(sizedImage(item.image, 200)) + '" alt="' + esc(item.product_title) + '" loading="lazy">'
                : '';
              var variant = (!item.product_has_only_default_variant && item.variant_title)
                ? '<div class="cart-drawer-variant">' + esc(item.variant_title) + '</div>' : '';
              return '<div class="cart-drawer-item" data-cart-item data-line-key="' + esc(item.key) + '">'
                + '<a href="' + esc(item.url) + '" class="cart-drawer-img">' + img + '</a>'
                + '<div class="cart-drawer-info">'
                + '<a href="' + esc(item.url) + '" class="cart-drawer-title">' + esc(item.product_title) + '</a>'
                + variant
                + '<div class="cart-drawer-meta">'
                + '<div class="qty-stepper" data-qty-stepper data-line-key="' + esc(item.key) + '">'
                + '<button type="button" data-qty-decrease aria-label="Decrease">' + ICON.minus + '</button>'
                + '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity">'
                + '<button type="button" data-qty-increase aria-label="Increase">' + ICON.plus + '</button>'
                + '</div>'
                + '<div class="cart-drawer-price">' + money(item.final_line_price) + '</div>'
                + '</div></div>'
                + '<button type="button" class="cart-drawer-remove" data-remove-item aria-label="Remove">' + ICON.close + '</button>'
                + '</div>';
            }).join('');
          } else {
            body.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p>'
              + '<a href="/collections/all" class="btn btn-gold" data-close-drawer>Shop Coffee</a></div>';
          }
        }
        // Footer (subtotal + actions) — present only when cart has items
        if (panel) {
          var footer = panel.querySelector('.cart-drawer-footer');
          if (cart.item_count > 0) {
            if (!footer) {
              footer = document.createElement('div');
              footer.className = 'cart-drawer-footer';
              footer.innerHTML = '<div class="cart-drawer-subtotal"><span>Subtotal</span>'
                + '<strong data-cart-subtotal></strong></div>'
                + '<p class="cart-drawer-note">Shipping &amp; taxes calculated at checkout.</p>'
                + '<form action="/cart" method="post">'
                + '<a href="/cart" class="btn btn-outline" style="width:100%;justify-content:center;margin-bottom:8px;">View Cart</a>'
                + '<button type="submit" name="checkout" class="btn btn-gold" style="width:100%;justify-content:center;">Checkout</button>'
                + '</form>';
              panel.appendChild(footer);
            }
            var sub = footer.querySelector('[data-cart-subtotal]');
            if (sub) sub.textContent = money(cart.total_price);
          } else if (footer) {
            footer.parentNode.removeChild(footer);
          }
        }
        // Count badges + bind close handlers on freshly-built nodes
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
        $$('#cart-drawer [data-close-drawer]').forEach(function (b) {
          if (!b.__bound) { b.__bound = true; b.addEventListener('click', function () { closeDrawer('cart-drawer'); }); }
        });
        return cart;
      })
      .catch(function () { return refreshCart(); });
  }

  // ─── Quick add (product cards) ─────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    var original = btn.innerHTML;
    btn.innerHTML = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.innerHTML = '✓';
      btn.style.background = 'var(--gold)';
      refreshCart();
      setTimeout(function () { openDrawer('cart-drawer'); refreshCartDrawer(); }, 300);
      setTimeout(function () {
        btn.innerHTML = original;
        btn.style.background = '';
        btn.disabled = false;
      }, 1800);
    }).catch(function () {
      btn.innerHTML = '!';
      setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1500);
    });
  });

  // ─── Product gallery thumbs ────────────────────────────────
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    $$('[data-thumb]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    var main = $('[data-main-media] img', gallery) || $('[data-main-media]', gallery);
    var src = thumb.getAttribute('data-media-src');
    var alt = thumb.getAttribute('data-media-alt') || '';
    if (main && main.tagName === 'IMG') {
      main.src = src;
      main.srcset = '';
      main.alt = alt;
    } else if (main) {
      main.innerHTML = '<img src="' + src + '" alt="' + alt + '">';
    }
  });

  // ─── Variant picker ────────────────────────────────────────
  function initVariantPicker(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function currentOptions() {
      var picked = {};
      $$('[data-option-value].is-selected', section).forEach(function (b) {
        picked[b.getAttribute('data-option-position')] = b.getAttribute('data-value');
      });
      return picked;
    }

    function matchVariant() {
      var picked = currentOptions();
      return variants.find(function (v) {
        return (!picked[1] || v.option1 === picked[1])
          && (!picked[2] || v.option2 === picked[2])
          && (!picked[3] || v.option3 === picked[3]);
      });
    }

    function updateUI() {
      var v = matchVariant();
      var hidden = $('[data-variant-id]', section);
      var priceEl = $('[data-current-price]', section);
      var atcText = $('[data-atc-text]', section);
      var atcPrice = $('[data-atc-price]', section);
      var atcBtn = $('[data-add-to-cart]', section);
      if (v) {
        if (hidden) hidden.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (atcPrice) atcPrice.textContent = money(v.price);
        if (atcBtn) {
          atcBtn.disabled = !v.available;
          if (atcText) {
            atcText.innerHTML = v.available
              ? 'Add to Cart — <span data-atc-price>' + money(v.price) + '</span>'
              : 'Sold Out';
          }
        }
        // Update URL with variant param without reload
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      // Update option display labels
      $$('[data-option-display]', section).forEach(function (el) {
        var pos = el.getAttribute('data-option-display');
        var sel = $('[data-option-value][data-option-position="' + pos + '"].is-selected', section);
        if (sel) el.textContent = sel.getAttribute('data-value');
      });
    }

    $$('[data-option-value]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        $$('[data-option-value][data-option-position="' + pos + '"]', section).forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        updateUI();
      });
    });
  }

  $$('[data-product-section]').forEach(initVariantPicker);

  // ─── Product form: AJAX add to cart ────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], #product-form');
    if (!form) return;
    // Only intercept forms with our add-to-cart button
    if (!form.querySelector('[data-add-to-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart], button[type=submit]');
    if (btn) btn.disabled = true;
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status >= 400) throw new Error(data.description || 'Error');
      refreshCartDrawer();
      openDrawer('cart-drawer');
      if (btn) {
        var orig = btn.innerHTML;
        btn.innerHTML = '<span data-atc-text>✓ Added to cart</span>';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1800);
      }
    }).catch(function (err) {
      if (btn) {
        btn.disabled = false;
        var t = form.querySelector('[data-atc-text]');
        if (t) t.textContent = 'Could not add — try again';
      }
    });
  });

  // ─── Quantity stepper (delegated; works in drawer + cart page + product) ──
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-decrease]');
    var inc = e.target.closest('[data-qty-increase]');
    if (!dec && !inc) return;
    var stepper = (dec || inc).closest('[data-qty-stepper]');
    if (!stepper) return;
    var input = stepper.querySelector('input');
    var current = parseInt(input.value, 10) || 0;
    var next = inc ? current + 1 : Math.max(0, current - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Debounced cart line update
  var qtyTimer;
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-qty-stepper] input')) return;
    var stepper = input.closest('[data-qty-stepper]');
    var lineKey = stepper.getAttribute('data-line-key');
    if (!lineKey) return; // product page input has no line key — handled by submit
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        refreshCartDrawer();
        // Reload cart page for line-total updates
        if (document.querySelector('[data-cart-form]')) {
          window.location.reload();
        }
      });
    }, 400);
  });

  // Remove item (drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-drawer [data-remove-item]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('[data-cart-item]');
    var lineKey = item && item.getAttribute('data-line-key');
    if (!lineKey) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function () { refreshCartDrawer(); });
  });

  // ─── Predictive search ────────────────────────────────────
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-search-input]')) return;
    var q = e.target.value.trim();
    var results = $('[data-search-results]');
    if (!results) return;
    clearTimeout(searchTimer);
    if (q.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) {
            results.innerHTML = '<p class="search-empty">No matches for "' + q + '"</p>';
            return;
          }
          results.innerHTML = '<div class="search-results-grid">' + products.map(function (p) {
            var img = p.image ? '<img src="' + p.image + '" alt="">' : '<span class="placeholder-glyph">☕</span>';
            return '<a href="' + p.url + '" class="search-result">'
              + '<div class="search-result-img">' + img + '</div>'
              + '<div class="search-result-info">'
              + '<div class="search-result-title">' + p.title + '</div>'
              + '<div class="search-result-price">' + p.price + '</div>'
              + '</div></a>';
          }).join('') + '</div>';
        });
    }, 220);
  });

  // ─── Collection filter / sort auto-submit ─────────────────
  document.addEventListener('change', function (e) {
    var input = e.target;
    var changedForm = input.closest('[data-collection-filter]');
    if (!changedForm) return;

    // Order forms so the one the user touched is processed LAST (its
    // single-value fields like sort_by win). Dedupe identical key=value
    // pairs so the desktop sidebar + mobile sheet don't double-count.
    var forms = $$('[data-collection-filter]').filter(function (f) { return f !== changedForm; });
    forms.push(changedForm);

    var singleKeys = { 'sort_by': 1 };
    var single = {};       // key -> value (last wins)
    var multi = [];        // ["key=value", …] deduped
    var seen = {};

    forms.forEach(function (f) {
      new FormData(f).forEach(function (v, k) {
        if (v === '' || v == null) return;
        if (singleKeys[k]) { single[k] = v; return; }
        var pair = k + '=' + v;
        if (!seen[pair]) { seen[pair] = 1; multi.push([k, v]); }
      });
    });

    var url = new URL(window.location.href);
    url.search = '';
    Object.keys(single).forEach(function (k) { url.searchParams.append(k, single[k]); });
    multi.forEach(function (p) { url.searchParams.append(p[0], p[1]); });
    window.location.search = url.search;
  });

  // ─── Mobile filter bottom-sheet ───────────────────────────
  $$('[data-open-filters]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openDrawer('filter-drawer'); });
  });
  $$('[data-close-filters]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); closeDrawer('filter-drawer'); });
  });

  // ─── Sticky add-to-cart bar (product, mobile) ─────────────
  var stickyBar = $('[data-sticky-atc]');
  if (stickyBar) {
    var realAtc = $('[data-add-to-cart]');
    var productSection = $('[data-product-section]');

    // Show bar once the main add-to-cart scrolls out of view
    if ('IntersectionObserver' in window && realAtc) {
      var barObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '-100px 0px 0px 0px' });
      barObs.observe(realAtc);
    } else {
      stickyBar.classList.add('is-visible');
    }

    // Keep the sticky price in sync with the live variant price
    if (productSection) {
      var priceSync = new MutationObserver(function () {
        var live = $('[data-current-price]', productSection);
        var stickyPrice = $('[data-sticky-price]', stickyBar);
        if (live && stickyPrice) stickyPrice.textContent = live.textContent;
        var stickyBtn = $('[data-sticky-add]', stickyBar);
        if (realAtc && stickyBtn) stickyBtn.disabled = realAtc.disabled;
      });
      var liveEl = $('[data-current-price]', productSection);
      if (liveEl) priceSync.observe(liveEl, { childList: true, characterData: true, subtree: true });
    }

    // Sticky button submits the real product form
    var stickyAdd = $('[data-sticky-add]', stickyBar);
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var form = $('#product-form');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  // ─── Lead-capture quote modal ─────────────────────────────
  (function () {
    var modal = document.getElementById('quote-modal');
    if (!modal) return;
    var formState = modal.querySelector('[data-quote-form-state]');
    var successState = modal.querySelector('[data-quote-success]');
    var form = modal.querySelector('#quote-form');
    var eyebrow = modal.querySelector('[data-quote-eyebrow]');
    var interestField = modal.querySelector('[data-quote-interest]');
    var submitLabel = modal.querySelector('[data-quote-submit-label]');

    function openQuote(label) {
      // Reset to form state each open
      if (formState) formState.hidden = false;
      if (successState) successState.hidden = true;
      var interest = label || 'Free Quote';
      if (eyebrow) eyebrow.textContent = interest;
      if (interestField) interestField.value = interest;
      if (submitLabel) submitLabel.textContent = interest.indexOf('Trial') > -1 || interest.indexOf('Tasting') > -1 ? 'Book My Free Trial' : 'Request My Free Quote';
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      setTimeout(function () { var fi = modal.querySelector('#q-name'); if (fi) fi.focus(); }, 200);
    }
    function closeQuote() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    }

    // Decide a friendly label from the trigger's text
    function labelFor(el) {
      var t = (el.textContent || '').toLowerCase();
      if (t.indexOf('trial') > -1 || t.indexOf('tasting') > -1) return 'Free Trial';
      return 'Free Quote';
    }

    // Triggers: explicit opt-in OR any link to the contact page OR #quote
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-quote], a[href$="#quote"], a[href*="/pages/contact"], a[href$="/contact"]');
      if (!trigger) return;
      e.preventDefault();
      openQuote(trigger.getAttribute('data-quote-label') || labelFor(trigger));
    });

    $$('[data-close-quote]').forEach(function (b) { b.addEventListener('click', closeQuote); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuote(); });

    // AJAX submit → thank-you
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.quote-submit');
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        fetch('/contact#contact_form', {
          method: 'POST',
          headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        }).then(function (r) {
          // Shopify redirects to ?contact_posted=true on success (fetch follows it → ok)
          if (formState) formState.hidden = true;
          if (successState) successState.hidden = false;
        }).catch(function () {
          if (formState) formState.hidden = true;
          if (successState) successState.hidden = false;
        });
      });
    }

    // Expose for the hero inline form etc.
    window.openQuoteModal = openQuote;
  })();

})();
